/*
 * action types
 */

export const REPLACE_COUNTRIES = "REPLACE_COUNTRIES";
export const CLEAR_COUNTRIES = "CLEAR_COUNTRIES";

/*
 * action creators
 */

export const Replace = (values) => ({ 
    type : REPLACE_COUNTRIES,
    countries: values,
});

export const Clear = () => ({
    type: CLEAR_COUNTRIES
})